var _createClass = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/helpers/createClass.js");

var _classCallCheck = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/helpers/classCallCheck.js");

/*
  This is a top-level library for the Adapters. This file loads all other
  adapter libraries.
*/
// Public npm libraries
// const EventEmitter = require('events')
// EventEmitter.defaultMaxListeners = 200
// Local libraries
var BchAdapter = require('./bch-adapter');

var IpfsAdapter = require('./ipfs-adapter');

var PubsubAdapter = require('./pubsub-adapter');

var EncryptionAdapter = require('./encryption-adapter');

var LogsAdapter = require('./logs-adapter');

var Gist = require('./gist');

var Adapters = /*#__PURE__*/function () {
  "use strict";

  function Adapters() {
    var localConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Adapters);

    // Dependency injection
    if (!localConfig.ipfs) {
      throw new Error('An instance of IPFS must be passed when instantiating the Adapters library.');
    }

    if (!localConfig.bchjs) {
      throw new Error('An instance of @psf/bch-js must be passed when instantiating the Adapters library.');
    } // Input Validation


    if (!localConfig.type) {
      throw new Error('The type of IPFS node (browser or node.js) must be specified.');
    } // BEGIN: Encapsulate dependencies
    // Create an event emitter for use by adapters.
    // this.eventEmitter = new EventEmitter()
    // this.eventEmitter.setMaxListeners(50)
    // localConfig.eventEmitter = this.eventEmitter


    this.log = new LogsAdapter(localConfig); // Pass the log adapter to all other adapters.

    localConfig.log = this.log;
    this.bch = new BchAdapter(localConfig); // Some adapter libraries depend on other adapter libraries. Pass them
    // in the localConfig object.

    localConfig.bch = this.bch;
    this.ipfs = new IpfsAdapter(localConfig);
    localConfig.ipfs = this.ipfs;
    this.encryption = new EncryptionAdapter(localConfig); // this.about = new AboutAdapter(localConfig)

    localConfig.encryption = this.encryption;
    this.pubsub = new PubsubAdapter(localConfig); // this.orbit = new OrbitDBAdapter(localConfig)

    this.gist = new Gist(localConfig); // END: Encapsulate dependencies
  }

  return _createClass(Adapters);
}();

module.exports = Adapters;